import { IBooleanResponse } from '@gem/models/commonModel';
import { IComplaintData, IComplaintReason, ISendComplaint } from '@gem/models/moderationModel';
import { logger } from '@gem/modules/logger';

import { buildModelError } from '../error/errorBuilder';

// Needs Bff implementation
export const getComplaintReasons = async (): Promise<IComplaintReason[]> => {
  try {
    return [];
  } catch (error) {
    logger.get('API').error('moderation.getComplaintReasons', error);
    throw buildModelError(error);
  }
};

// Needs Bff implementation
export const sendComplaint = async <T = IComplaintData>(
  data: ISendComplaint<T>
): Promise<IBooleanResponse> => {
  try {
    return { result: false };
  } catch (error) {
    logger.get('API').error('moderation.sendComplaint', error);
    throw buildModelError(error);
  }
};
